module.exports = __webpack_public_path__ + "img/image31.0aa55e8e.jpg";